import { connect } from 'react-redux';
import get from 'lodash/get';
import { getPensionExpert } from '../../redux/selectors/investmentAdvice';
import { tierFromEmail, TIERS, titleForTier } from './pensionExpertTierHelper';

const withPensionExpertTier = (WrappedComponent) => {
  const mapStateToProps = (state) => {
    const pensionExpert = getPensionExpert(state);
    const email = get(pensionExpert, 'email');
    const expertTier = tierFromEmail(email);
    const expertRoleTitle = titleForTier(expertTier);
    const isPoolExpert = expertTier === TIERS.POOL;
    const isAdviser = expertTier === TIERS.ADVISER;
    return {
      pensionExpert,
      expertTier,
      expertRoleTitle,
      isPoolExpert,
      isAdviser,
    };
  };

  return connect(mapStateToProps)(WrappedComponent);
};

export default withPensionExpertTier;
